<template>
  <Toast :close-tip="true" class="flail" :close-event="closeEvent">
    <img style="margin-top: -5px;" src="@/assets/img/share-fail.png"
      srcset="@/assets/img/share-fail@2x.png 2x,@/assets/img/share-fail@3x.png 3x">
    <p class="info">抱歉，当前活动太火爆请您稍后再试。</p>
    <img src="@/assets/img/dialog-pic.png" srcset="@/assets/img/dialog-pic@2x.png 2x,@/assets/img/dialog-pic@3x.png 3x">
    <p class="btn">进店逛逛</p>
  </Toast>
</template>

<script>
import Toast from "./../VueToast"
export default {
  name: 'FailShare',
  props: {
    closeEvent: Function
  },
  components: {
    Toast
  },
  methods: {
  }

}
</script>

<style lang="scss" scoped>
.flail {
  .info {
    color: #666;
    margin: 10px 0 20px;
  }
  .btn {
    height: 35px;
    width: 120px;
    margin: 20px auto;
    line-height: 34px;
    background-image: url("./../../../assets/img/dialog-btn.png");
    background: -webkit-image-set(
      url("./../../../assets/img/dialog-btn.png") 1x,
      url("./../../../assets/img/dialog-btn@2x.png") 2x,
      url("./../../../assets/img/dialog-btn@3x.png") 3x
    );
    background-repeat: no-repeat;
    background-size: 100%;
    color: #fff;
  }
}
</style>